import React, {useState, useEffect} from 'react';
import LoginForm from '../form_elements/LoginForm';
import AdminPanel from '../subpages/AdminPanel';
import Dropdownlist from '../customComponents/Dropdownlist';

import styles from "../../assets/stylesheets/sass/Login.module.scss";
import logo from "../../assets/images/logo.svg";
import logo_white from "../../assets/images/logo_white.svg";


export default function Admin({}){
    const [loggedIn, setloggedIn] = useState(false);

	return (
	    <>
        {!loggedIn ? 
        <div className={styles.main_container}>
            <div>
                <div className={styles.logo_container}>
                    <img className={styles.logo} src={logo} alt="logo"/>
                    <img className={styles.logo_white} src={logo_white} alt="logo"/>
                </div>
                <div className={styles.login_form}>
                    <LoginForm title="Log in - Admin" typeLogin="admin" loggedInLogin={(v)=>setloggedIn(v)}/>
                </div>
                <div className={styles.language_ddl}>
                    <Dropdownlist data={["Nederlands", "Frans", "Engels"]} menuPlacement="auto" isSearchable={false} defaultValue type="language" width="small"/>
                </div>
            </div>
            <div style={{position:"relative"}} className={styles.right_container}>
				<div style={{marginTop:"-4rem", marginLeft:"4rem"}}>
					<p style={{fontSize:"3.7rem"}}>Welkom bij het <span style={{fontWeight:"bold"}}>Admin Paneel</span></p>
					<p style={{fontSize:"1rem", marginTop:"1rem"}}>Log in om toegang te krijgen tot uw account</p>
				</div>
			</div>
        </div>
        :
        <div>
            <AdminPanel onLogout={(v)=>{setloggedIn(false)}}/>
        </div>
        }	    	
	    </>  
  	);
}